import { FC } from 'react';
import './SignIn.scss';

const SignIn: FC = () => {
	return <div>Sign IN Under construction</div>;
};

export default SignIn;
